export default __webpack_public_path__ + "static/media/logo.7cb049ea.svg";